<template lang="html">
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item" @click="$router.push('/catalogs')" style="cursor: pointer">Catálogos</li>
        <li class="breadcrumb-item active" aria-current="page">Eventos de Cobranza</li>
      </ol>
    </nav>

    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <vs-card>
            <template slot="header">
              <div class="flex">
                <h2 class="flex-1">Eventos de cobranza</h2>
                <vs-button icon="add" v-on:click="addEvent"></vs-button>
              </div>
            </template>
            <div>
                <vs-table
                    :sst="true"
                    @sort="handleSort"
                    ref="table"
                    stripe
                    :max-items="30"
                    :data="allEvents"
                    noDataText="No hay datos disponibles"
                >
                    <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
                    <div class="pager" v-if="allEvents.length > 0">
                        <div class="flex flex-wrap">
                        <vs-button
                            :disabled="allData.prev_page_url ? null:true"
                            type="border"
                            radius
                            @click="pager(allData.prev_page_url)"
                            class="mr-2"
                            icon-pack="feather"
                            icon="icon-chevron-left"
                        ></vs-button>
                        <vs-button
                            v-if="allData.prev_page_url != null"
                            text-color="#212121"
                            type="flat"
                            radius
                            @click="pager(allData.first_page_url)"
                            class="rounded-circle mr-2"
                        >
                            <strong>1 ..</strong>
                        </vs-button>
                        <vs-button type="flat" text-color="dark" radius class="mr-2">
                            <strong>{{ allData.current_page }}</strong>
                        </vs-button>
                        <vs-button
                            v-if="allData.next_page_url != null"
                            text-color="#212121"
                            type="flat"
                            radius
                            @click="pager(allData.last_page_url)"
                            class="rounded-circle mr-2"
                        >
                            <strong>.. {{ allData.last_page }}</strong>
                        </vs-button>
                        <vs-button
                            :disabled="allData.next_page_url ? null:true"
                            type="border"
                            radius
                            @click="pager(allData.next_page_url)"
                            class="mr-2"
                            icon-pack="feather"
                            icon="icon-chevron-right"
                        ></vs-button>
                        </div>
                    </div>
                    <!-- ITEMS PER PAGE -->
                    <div
                        v-if="totalRecords > 0"
                        class="p-3 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
                    >
                        <span class="mr-2">{{ from }} - {{ to }} de {{ totalRecords }}</span>
                    </div>
                    </div>
                    <template slot="thead">
                    <vs-th
                        class="bold"
                        v-for="(col, idx) in columns"
                        v-bind:key="idx"
                        :sort-key="col.sortable ? col.key : null"
                    >{{col.title}}</vs-th>
                    </template>

                    <template slot-scope="{data}">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data" :data="tr">
                      <vs-td>{{ tr.id }}</vs-td>
                      <vs-td>{{ tr.type_str }}</vs-td>
                      <vs-td>{{ tr.event }}</vs-td>
                      <vs-td>
                        <vs-button
                          radius
                          color="primary"
                          type="filled"
                          icon-pack="feather"
                          icon="icon-edit"
                          @click="editEvent(tr)"
                        ></vs-button>
                      </vs-td>
                      <vs-td>
                        <vx-tooltip text="El evento puede ser eliminado solo si no se ha enviado a ningun solicitante.">
                          <vs-button
                            :disabled="!tr.can_be_deleted"
                            radius
                            color="danger"
                            type="filled"
                            icon-pack="feather"
                            icon="icon-trash"
                            @click="confirmDeleteEvent(tr.id)"
                          ></vs-button>
                        </vx-tooltip>
                      </vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
            </div>
          </vs-card>
        </div>
      </div>
    </div>
    <div class="modal fade" id="modal_new_event" tabindex="-1" role="dialog" aria-labelledby="modal_new_event_label" aria-hidden="true">
        <div class="modal-dialog modal-reports modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h3 class="modal-title" id="modal_new_event_label">{{titleModal}}</h3>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="skinny row">
                        <div class="col-md-12">
                            <!-- <div class="vx-col w-full">
                                <vs-select class="w-full mb-2"
                                    label="Selecciona una categoria para el evento."
                                    v-model.lazy="currentEvent.event_type"
                                    name="currentEvent.event_type"
                                    placeholder="Seleccione una opción" >
                                    <vs-select-item :key="index" :value="item.value" :text="item.type" v-for="(item,index) in eventTypes" class="w-full" />
                                </vs-select>
                            </div> -->
                            <label>Título:</label>
                            <div class="vx-col w-full">
                              <vs-input class="w-full" placeholder="Ingrese" v-model="currentEvent.title" />
                            </div>
                            <label class="mt-5">Mensaje del evento:</label>
                            <p>
                              <vx-list :list="['Recuerda no incluir más de una vez cualquiera de las siguientes opciones.', 'Para incluir una fecha escribe: %date% en la ubicación deseada.',
                              'Para incluir un monto escribe: %amount% en la ubicación deseada.','Para incluir un medio de contacto escribe: %contact% en la ubicación deseada.']" />
                            </p>
                            <vx-textarea v-model="currentEvent.event" height="300px"/>
                            <div class="flex flex-wrap">
                                <vs-button :disabled="currentEvent.event.length == 0" color="success" @click="saveEvent()">Guardar</vs-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script lang="js">
    const columnDefinitions = [
        { title: "ID", key: "id", sortable: true },
        { title: "TIPO", key: "type_str", sortable: true },
        { title: "EVENTO", key: "event", sortable: true },
        { title: "EDITAR", key: "edit", sortable: false },
        { title: "ELIMINAR", key: "delete", sortable: false },
    ];

  export default  {
    name: 'cashing-events',
    props: [],
    async mounted() {
      await this.getCashingEvents();
    },
    data() {
      return {
        titleModal: "Nuevo evento de cobranza",
        columns: columnDefinitions,
        allData: {
          data: []
        },
        currentEvent: {
            id:-1,
            title:"",
            event:"",
            event_type:"cashing_manual"
        },
        eventIdToDelete:-1,
        date: false,
        showDialog: false,
        eventTypes: [
            { type: "Predeterminado", value: "status_change_auto" },
            { type: "Pagos", value: "applicant_payments_auto" },
            { type: "Cobranza", value: "cashing_manual" },
            { type: "Negociación (sin recargos)", value: "surcharges_negotiation_auto" },
            { type: "Negociación (meses de gracia)", value: "grace_months_negotiation_auto" },
            { type: "Negociación (solo intereses)", value: "only_interest_negotiation_auto" },
        ],
      }
    },
    computed: {
        allEvents() {
          return this.allData.data;
        },
        from() {
          return this.allData.from;
        },
        to() {
          return this.allData.to;
        },
        totalRecords() {
          return this.allData.total;
        }
    },
    methods: {
      async getCashingEvents(url = '/api/catalogs/cashing_events'){
        this.showLoading(true);
        await axios.get(url).then(response => {
            this.allData = response.data;
        });
        this.showLoading(false);
      },
      addEvent(){
          this.resetValues();
          $('#modal_new_event').modal('show');
      },
      editEvent(event){
        this.currentEvent.id = event.id;
        this.currentEvent.title = event.title;
        this.currentEvent.event = event.event;
        this.currentEvent.event_type = event.event_type;
        $('#modal_new_event').modal('show');
      },
      async saveEvent(){
        this.showLoading(true);
        await axios.post( '/api/catalogs/cashing_events/save', {
          'id': this.currentEvent.id,
          'title': this.currentEvent.title,
          'event': this.currentEvent.event,
          'event_type': this.currentEvent.event_type
        }).then(response => {
          this.resetValues();
          this.showLoading(false);
          $('#modal_new_event').modal('hide');
          this.getCashingEvents();
          this.successNotif("Aviso", 'Evento guardado correctamente');
        }).catch(error => {
            this.showLoading(false);
            this.errorNotif("Aviso", 'Parece que ha ocurrido un error, intente más tarde', 4000);
        });
      },
      confirmDeleteEvent(id){
          this.eventIdToDelete = id;
          this.$vs.dialog({
              type: 'confirm',
              color: 'danger',
              title: `Aviso`,
              text: '¿Estas seguro de querer eliminar el evento?',
              acceptText: "Confirmar",
              cancelText: "Cancelar",
              accept: this.deleteEvent
          })
      },
      async deleteEvent(){
        this.showLoading(true);
        await axios.post( '/api/catalogs/cashing_events/delete', {
          'id': this.eventIdToDelete,
        }).then(response => {
          this.showLoading(false);
          this.eventIdToDelete=-1;
          this.getCashingEvents();
          this.successNotif("Aviso", 'Evento eliminado correctamente', 4000);
        }).catch(error => {
            this.showLoading(false);
            this.errorNotif("Aviso", 'Parece que ha ocurrido un error, intente más tarde', 4000);
        });
      },
      async handleSort(key, active) {
          this.allEvents.sort();
      },
      async pager(url) {
          await this.getCashingEvents(url);
      },
      resetValues(){
          this.eventIdToDelete=-1;
          this.currentEvent.id = -1;
          this.currentEvent.title = "";
          this.currentEvent.event = "";
          this.currentEvent.event_type = "cashing_manual";
      }
    }
}
</script>

<style scoped>
/* Customize the label (the container) */
.container {
  display: block;
  position: relative;
  padding-left: 35px;
  margin-bottom: 35px;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default checkbox */
.container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 25px;
  width: 25px;
  background-color: #eee;
  margin-left: 30%;
  border-radius: 30px;
}

/* On mouse-over, add a grey background color */
.container:hover input ~ .checkmark {
  background-color: #ccc;
}

/* When the checkbox is checked, add a blue background */
.container input:checked ~ .checkmark {
  background-color: rgb(243, 205, 33);
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.container input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.container .checkmark:after {
  left: 9px;
  top: 5px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
</style>
